import { ActionCreatorWithPayload } from '@reduxjs/toolkit';
import { shallowEqual, useDispatch, useSelector } from 'react-redux';
import { IState } from '../types';

const useComment = <StateType>(
  selector: (state: IState) => StateType,
  createAction: ActionCreatorWithPayload<StateType, string>
): [StateType, (value: StateType) => void] => {
  const comment = useSelector<IState, StateType>(selector, shallowEqual);

  const dispatch = useDispatch();
  const saveComment = (value: StateType) => {
    dispatch(createAction(value));
  };

  return [comment, saveComment];
};

export default useComment;
